export enum AccountStagesLocators {
	accountStagesCancelButton = 'accountStagesCancelButton',
	accountStagesCancelSaveButton = 'accountStagesCancelSaveButton',
	accountStagesCancelCancelButton = 'accountStagesCancelCancelButton',
	accountStages = 'accountStages',
}
